import { forwardRef, useImperativeHandle, useState } from 'react'
import { useTheme } from '@mui/material'
import { defaultStyles, TooltipWithBounds } from '@visx/tooltip'
import { ToolTipView } from './ToolTipView'
import { ParticipantChartMetaInfo } from './OIChart'

export type OIChartTooltipPayload = {
    left: number
    top: number
    data: { data: { date: string } & Record<string, unknown> }
}

export type OIChartTooltipHandle = {
    show: (payload: OIChartTooltipPayload) => void
    hide: () => void
}

type Props = {
    keys: string[]
    metaInfo: ParticipantChartMetaInfo
}

const OIChartTooltipHost = forwardRef<OIChartTooltipHandle, Props>(function OIChartTooltipHost(
    { keys, metaInfo },
    ref
) {
    const theme = useTheme()
    const [tooltip, setTooltip] = useState<OIChartTooltipPayload | null>(null)

    useImperativeHandle(
        ref,
        () => ({
            show: (payload) => setTooltip(payload),
            hide: () => setTooltip(null),
        }),
        []
    )

    if (!tooltip) {
        return null
    }

    return (
        <TooltipWithBounds
            top={tooltip.top}
            left={tooltip.left}
            style={{
                ...defaultStyles,
                position: 'absolute',
                textAlign: 'left',
                padding: 0,
                margin: 0,
                backgroundColor: theme.palette.background.default,
            }}
        >
            <ToolTipView
                keys={keys}
                leftScaleKeys={[]}
                data={tooltip.data}
                colors={metaInfo.colors}
                specificColors={metaInfo.specificColors}
            />
        </TooltipWithBounds>
    )
})

export default OIChartTooltipHost
